export class ScheduledTask {
    constructor(init = {}) {
        Object.assign(this, init);
        this.promise = new Promise((res, rej) => {
            this.resolve = res;
        });
    }
    promise;
    unique;
    action;
    resolve;
    skipIfContains;
}
